export enum AtWorkGroup {
  Candidate = "aw-candidate-group",
  Employee = "aw-employee-group",
  HRGeneralist = "aw-hr-generalist-group",
  HRRecruiter = "aw-hr-recruiter-group",
  Manager = "aw-manager-group",
  OrgAdmin = "aw-org-admin-group",
  PayrollAdmin = "aw-payroll-admin-group",
  Procurement = "aw-procurement-group",
}

export enum AtWorkCSRGroup {
  CSRAdmin = "aw-csr-admin-group",
}